import { isNotNilOrEmpty } from '../../value/isNotNilOrEmpty';
/**
 * Returns true if {value} has equality with any item in {args}
 *
 * @since v1.4.0
 * @category Logic
 * @template {T} - The type of value
 * @param {T} value - The value to compare against
 * @param {*[]} args - Known values to compare against {value}
 * @returns {boolean}
 * @example
 * or('item', 25, 7, 'item');
 * @docgen_example
 * or('item', 25, 7, 'something');
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var or = function (value) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return isNotNilOrEmpty(args) ? args.some(function (x) { return x === value; }) : false;
};
